<div class="trash-header-container">
  <div class="trash-header">
    <div class="description">
      <rk-page-title
        [title]="'MEDIA.TRASH.TITLE' | translate"
        [icon]="'fa-trash'"
      ></rk-page-title>
      <div class="action">
        <div class="buttons">
          <rk-button
            label="{{ 'MEDIA.TRASH.EMPTY_BUTTON' | translate }}"
            (click)="emptyTrash()"
            [disabled]="!(archivedTracksLength$ | async)"
          ></rk-button>
        </div>
      </div>
      <div class="trash-length-search flex justify-between items-end">
        <span class="meta" *ngIf="!currentSearchValue">
          {{ 'MEDIA.TRASH.STORAGE_INFO' | translate }}
        </span>
        <span
          *ngIf="currentSearchValue"
          class="filtering"
          [innerHTML]="
            'MEDIA.TRASH.SEARCHING'
              | translate
                : {
                    displayed: displayedArchivedTracksLength,
                    total: archivedTracksLength$ | async
                  }
          "
        ></span>
        <div class="right-side">
          <div class="search" [class.hidden]="!(archivedTracksLength$ | async)">
            <rk-search-bar (inputted)="editSearch($event)"></rk-search-bar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
